import React from "react";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { Chip } from "@mui/material";
import RatingMUI from "./RatingMUI";

const PortfolioGridTable = () => {
  const columns = [
    { field: "id", headerName: "ID", width: 20, hide: true },
    {
      field: "buildingName",
      headerName: "Building Name",
      width: 250,
      editable: false,
    },
    {
      field: "builtYear",
      headerName: "Built Year",
      width: 100,
      editable: false,
    },
    {
      field: "location",
      headerName: "Location",
      width: 180,
      editable: false,
    },
    {
      field: "buildingType",
      headerName: "Building Type",
      width: 140,
      editable: false,
    },
    {
      field: "managedSpace",
      headerName: "Managed Square Footage",
      width: 120,
      editable: false,
    },
    {
      field: "numOfFloor",
      headerName: "Number of Floors",
      width: 120,
      editable: false,
    },
    {
      field: "numOfEmployee",
      headerName: "Number of Employees",
      width: 120,
      editable: false,
    },
    {
      field: "employeeSatisfaction",
      headerName: "Employee Satisfaction",
      width: 150,
      editable: false,
      renderCell: (params) => {
        return <RatingMUI value={params.value} />;
      },
    },
    {
      field: "hpi",
      headerName: "HPI Level",
      width: 130,
      editable: false,
      renderCell: (params) => {
        let label = "Good";
        if (Number(params.value) === 5) {
          label = "Good";
        } else if (Number(params.value) === 4) {
          label = "Moderate";
        } else if (Number(params.value) === 3) {
          label = "Unhealthy-Sensitive";
        } else if (Number(params.value) === 2) {
          label = "Unhealthy";
        } else if (Number(params.value) === 1) {
          label = "Very Unhealthy";
        } else if (Number(params.value) === 0) {
          label = "Hazardous";
        }

        const chipStyle = {
          width: "100px",
          color: "white",
          backgroundColor: (() => {
            switch (params.value) {
              case 5:
                return "#70ad47"; // Color for "Completed"
              case 4:
                return "#ffff00"; // Color for "To be configured"
              case 3:
                return "#ff0000";
              case 2:
                return "#ffc000";
              case 1:
                return "#c00000";
              case 0:
                return "#7030a0";
              default:
                return "#70ad47"; // Default color for other statuses
            }
          })(),
        };

        return <Chip label={label} style={chipStyle} />;
      },
    },
    {
      field: "avgOccupancyRate",
      headerName: "Average Occupancy Rate",
      width: 180,
      editable: false,
    
    },
    {
      field: "physicalSecurityIncidents",
      headerName: "Physical Security Incidents",
      width: 180,
      editable: false,
    },
  ];

  const rows = [
    {
      id: 1,
      buildingName: "Contoso Tower - Toronto",
      builtYear: 2010,
      location: "Downtown Toronto, ON",
      buildingType: "Office",
      managedSpace: 150000,
      numOfFloor: 25,
      numOfEmployee: 500,
      employeeSatisfaction: 4,
      hpi: 3,
      avgOccupancyRate: 90,
      physicalSecurityIncidents: 1,
    },
    {
      id: 2,
      buildingName: "Contoso Plaza - Ottawa",
      builtYear: 2015,
      location: "ByWard Market, Ottawa, ON",
      buildingType: "Mixed-Use",
      managedSpace: 120000,
      numOfFloor: 20,
      numOfEmployee: 300,
      employeeSatisfaction: 5,
      hpi: 5,
      avgOccupancyRate: 85,
      physicalSecurityIncidents: 0,
    },
    {
      id: 3,
      buildingName: "Contoso Residences - Vancouver",
      builtYear: 2018,
      location: "Coal Harbour, Vancouver, BC",
      buildingType: "Residential",
      managedSpace: 90000,
      numOfFloor: 18,
      numOfEmployee: 50,
      employeeSatisfaction: 4,
      hpi: 3,
      avgOccupancyRate: 92,
      physicalSecurityIncidents: 2,
    },
    {
      id: 4,
      buildingName: "Contoso Innovation Hub - Calgary",
      builtYear: 2021,
      location: "Downtown Calgary, AB",
      buildingType: "Office",
      managedSpace: 200000,
      numOfFloor: 30,
      numOfEmployee: 800,
      employeeSatisfaction: 5,
      hpi: 5,
      avgOccupancyRate: 88,
      physicalSecurityIncidents: 1,
    },
    {
      id: 5,
      buildingName: "Contoso Heights - Montreal",
      builtYear: 2016,
      location: "Plateau Mont-Royal, Montreal, QC",
      buildingType: "Residential",
      managedSpace: 110000,
      numOfFloor: 22,
      numOfEmployee: 100,
      employeeSatisfaction: 4,
      hpi: 2,
      avgOccupancyRate: 87,
      physicalSecurityIncidents: 0,
    },
    {
      id: 6,
      buildingName: "Contoso Wellness Center - Halifax",
      builtYear: 2012,
      location: "Downtown Halifax, NS",
      buildingType: "Healthcare",
      managedSpace: 95000,
      numOfFloor: 10,
      numOfEmployee: 300,
      employeeSatisfaction: 3,
      hpi: 5,
      avgOccupancyRate: 95,
      physicalSecurityIncidents: 1,
    },
    {
      id: 7,
      buildingName: "Contoso Retail Space - Edmonton",
      builtYear: 2019,
      location: "West Edmonton Mall, AB",
      buildingType: "Commercial",
      managedSpace: 130000,
      numOfFloor: 3,
      numOfEmployee: 150,
      employeeSatisfaction: 4,
      hpi: 3,
      avgOccupancyRate: 80,
      physicalSecurityIncidents: 2,
    },
    {
      id: 8,
      buildingName: "Contoso Eco Park - Saskatoon",
      builtYear: 2020,
      location: "Meewasin Valley, Saskatoon, SK",
      buildingType: "Mixed-Use",
      managedSpace: 70000,
      numOfFloor: 6,
      numOfEmployee: 80,
      employeeSatisfaction: 5,
      hpi: 5,
      avgOccupancyRate: 90,
      physicalSecurityIncidents: 0,
    },
    {
      id: 9,
      buildingName: "Contoso Tower - Victoria",
      builtYear: 2014,
      location: "Downtown Victoria, BC",
      buildingType: "Office",
      managedSpace: 160000,
      numOfFloor: 20,
      numOfEmployee: 400,
      employeeSatisfaction: 3,
      hpi: 3,
      avgOccupancyRate: 75,
      physicalSecurityIncidents: 3,
    },
    {
      id: 10,
      buildingName: "Contoso Conference Center - Winnipeg",
      builtYear: 2018,
      location: "The Forks, Winnipeg, MB",
      buildingType: "Event Space",
      managedSpace: 85000,
      numOfFloor: 4,
      numOfEmployee: 60,
      employeeSatisfaction: 4,
      hpi: 5,
      avgOccupancyRate: 95,
      physicalSecurityIncidents: 0,
    },
  ];

  return (
    <>
      <Box sx={{ height: "350px", width: "100%", overflow: "auto" }}>
        <DataGrid
          sx={{
            color: "white",
            "& .MuiDataGrid-menuIconButton": {
              color: "white",
            },
            "& .MuiCheckbox-root": {
              color: "white",
            },

            "& .MuiDataGrid-sortIcon": {
              color: "white",
            },

            "& .MuiTablePagination-root": {
              bgcolor: "white",
            },
            "& .MuiDataGrid-cell": {
              border: 0,
            },
            "& .MuiDataGrid-row:hover": {
              bgcolor: "primary.main",
            },
            "& .MuiDataGrid-cell:hover": {
              bgcolor: "none",
            },
            "& .MuiDataGrid-cell:focus": {
              bgcolor: "primary.light",
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              fontWeight: "bold",
              lineHeight: "1.5",
              whiteSpace: "normal",
            },

            "& .MuiDataGrid-cell": {
              textAlign: "center", // Centering cell content
              
            },
          }}
          rows={rows}
          columns={columns}
          initialState={{}}
          checkboxSelection
          disableRowSelectionOnClick
        />
      </Box>
    </>
  );
};

export default PortfolioGridTable;
